import englandIcon from '~/assets/icons/flags/england.png';
import franceIcon from '~/assets/icons/flags/france.png';
import EnglishLogo from '~/assets/icons/flags/english-flag.png';
import FrenchLogo from '~/assets/icons/flags/french-flag.png';
// import chinaIcon from '~/assets/icons/flags/ch.png';

export type Language = { label: string; icon: string; flatIcon: string };

export const languages: Language[] = [
  {
    label: 'en',
    icon: englandIcon,
    flatIcon: EnglishLogo,
  },
  {
    label: 'fr',
    icon: franceIcon,
    flatIcon: FrenchLogo,
  },
  // {
  //   label: 'zh',
  //   icon: chinaIcon,
  // },
];

export const getLanguage = (label: string) => languages.find(language => language.label === label) || languages[0];
